import React from 'react'
import './Hero.css'

const Hero = () => {
  return (
    <section id='home'>
        <div className='container'>
            <div className='hero-left'>
                <h1>hi i’m Mohcin Charef. <br />Web designer and frontend developer </h1>
                <p>I will help you to get the exact design and project result that you are looking for.</p>
                <div>
                    <a href='#projects' className='primary-btn'>My Work</a>
                    <a href='#contact' className='secondary-btn'>Contact</a>
                </div>
            </div>
            <div className='hero-right'>
                <img src='./assets/hero.png' alt='' />
            </div>
        </div>
    </section>
  )
}

export default Hero